import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Services from '../services';
import SwichButton from '../../../commons/SwitchButton';
import SelectField from '../../../components/Form/SelectField'
import RFForm from '../../../components/Form/RFForm';

const COL_STYLE = {marginBottom: '15px'};
const ROW_STYLE = {marginLeft: '15px', marginRight: '15px'};
const VasarloiKartyaFilter = props => {
  const {
    setFilter,
    kartyaTipus
  } = props;

  const [allCards, toggleAllCards] = useState('AKTIV');
  const [type, setType] = useState(null);
  const [location, setLocation] = useState(null);
  const [owner, setOwner] = useState(null);
  const [group, setGroup] = useState(null);
  const [code, setCode] = useState(null);
  const active = allCards === 'AKTIV';

  useEffect(() => {
      setFilter(
        {
          aktiv: allCards,
          kartyaId: code && code.id,
          kartyaTipusId: type && type.id,
          helyszinId: location && location.id,
          tulajdonosId: owner && owner.id,
          csoport: group && group.name,
        }
      );
  }, [allCards, type, location, owner, group, code]);

  useEffect(() => {
    setType(kartyaTipus);
  }, [kartyaTipus]);

  const styles = {
    control: base => ({
      ...base,
      '&:focus': { borderColor: 'red' }, // border style on hover
      border: '1px solid lightgray', // default border color
      boxShadow: 'none', // no box-shadow
      borderRadius: '0'
    }),
  };

  const loadHelyszinOptions = (input, callback) => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !location && options.length === 1) {
          setLocation(options[0]);
        }
      }
    });
  }

  const loadKartyaTipusOptions = (input, callback) => {
    Services.listKartyaTipus(false, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !type && options.length === 1) {
          setType(options[0]);
        }
      }
    });
  }

  const loadVasarloiKartyaOptions = (input, callback) => {
    Services.listVasarloiKartyaAzons(input, (err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadTulajdonosOptions = (input, callback) => {
    const kartyaTipusId = type && type.id;
    Services.searchTulajdonos(kartyaTipusId, input, (err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadCsoportOptions = (input, callback) => {
    Services.listVasarloiKartyaCsoport((err, res) => {
      if (!err) {
        let options = [];
        res[0]
          .map(k => {
            return {name: k, label:k}
          })
          .filter( k => k ? k.name.toLowerCase().includes(input.toLowerCase()) : false).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  return(
    <React.Fragment>
      <div className="row" >
        <div className="col-md-2">
          <h5>Szűrési feltételek: </h5>
        </div>
      </div>
      <RFForm>
        <div className="row" style={ROW_STYLE}>
          <div className="col-md-2" style={COL_STYLE}>
            <SelectField
              variant='async'
              name="Location"
              id="Location"
              placeholder="Helyszín..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setLocation(v)}
              loadOptions={_.debounce(loadHelyszinOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={location}
              defaultOptions
              isClearable
            />
          </div>
          <div className="col-md-2" style={COL_STYLE}>
            <SelectField
              variant='async'
              name="Type"
              id="Type"
              placeholder="Kártyatípus..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setType(v)}
              loadOptions={_.debounce(loadKartyaTipusOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={type}
              defaultOptions
              isClearable
            />
          </div>
          {type && allCards == 'AKTIV' && (
            <div className="col-md-2" style={COL_STYLE}>
              <SelectField
                variant='async'
                name="Owner"
                id="Owner"
                placeholder="Tulajdonos..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => setOwner(v)}
                loadOptions={_.debounce(loadTulajdonosOptions, 1000)}
                getOptionLabel={option => option.nev}
                getOptionValue={option => option.id}
                value={owner}
                //defaultOptions
                isClearable
              />
            </div>
          )}
          <div className="col-md-2" style={COL_STYLE}>
            <SelectField
              variant='async'
              name="Group"
              id="Group"
              placeholder="Csoport..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setGroup(v)}
              loadOptions={_.debounce(loadCsoportOptions, 1000)}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.name}
              value={group}
              //defaultOptions
              isClearable
            />
          </div> 
          <div className="col-md-2" style={COL_STYLE}>
            <SelectField
              variant='async'
              name="Code"
              id="Code"
              placeholder="Azonosító..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setCode(v)}
              loadOptions={_.debounce(loadVasarloiKartyaOptions, 1000)}
              getOptionLabel={option => option.azonosito}
              getOptionValue={option => option.id}
              value={code}
              //defaultOptions
              isClearable
            />
          </div>
          <div className="col-md-2" style={COL_STYLE}>
            <SwichButton
              active={active}
              trueLabel="Aktív"
              trueToggle={() => toggleAllCards('AKTIV')}
              trueWidth={80}
              falseToggle={() => { setOwner(null); toggleAllCards('INAKTIV')} }
              falseLabel="Inaktív"
              falseWidth={80}
            />
          </div>
        </div>
      </RFForm>
    </React.Fragment>
  );
}

export default VasarloiKartyaFilter;